import api from '../../apiConfig/apiConfig';
import { Get, Post } from '../base/baseAjax';

// 评价统计
let evaluateStat = (params) => {
  return Post({
    url: api.kit.evaluateStat,
    bodyParam: params,
  });
};

// 评价导出
let evaluateExport = (params) => {
  return Post({
    url: api.kit.evaluateExport,
    bodyParam: params,
    config: {
      responseType: 'blob',
    },
  });
};

// 评论详情
let evaluateDetail = (params) => {
  return Get({
    url: api.kit.evaluateDetail,
    PathParam: params,
  });
};

export default {
  evaluateStat,
  evaluateExport,
  evaluateDetail,
};
